import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usuario-email',
  templateUrl: './usuario-email.component.html',
  styleUrls: ['./usuario-email.component.css']
})
export class UsuarioEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
